import React from 'react';
import { Icon } from 'antd';
import PropTypes from 'prop-types';

const Loading = ({ size, style = {} }) => (
  <span className="loading" style={{ fontSize: size, ...style }}>
    <Icon type="loading" />
  </span>
);

Loading.defaultProps = {
  size: 20,
};

Loading.propTypes = {
  size: PropTypes.number,
  style: PropTypes.object,
};

export default Loading;
